var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfbuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Buy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.83 48 2.58-2.59a2 2 0 0 0-.41-3.12l-20-12A2 2 0 0 0 30.29 33l12 20a2 2 0 0 0 1.47.95A1 1 0 0 0 44 54a2 2 0 0 0 1.41-.59L48 50.83l6.59 6.58a2 2 0 0 0 2.82-2.82Zm-6.43.77-6.57-10.94 10.94 6.57Z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6a11.51 11.51 0 0 0-11.5 11.5v.5h-4a6 6 0 0 0-5.93 5.18l-3.88 28a6 6 0 0 0 5.9 6.82h30l-2.4-4h-27.6a2 2 0 0 1-2-2.27l3.88-28a2 2 0 0 1 2-1.73l31.16-.06a2 2 0 0 1 2 1.73l2 15.15 4.39 2.63-2.44-18.33a6 6 0 0 0-5.94-5.2H43.5v-.42A11.51 11.51 0 0 0 32 6Zm7.5 11.94h-15v-.44a7.5 7.5 0 0 1 15 0Z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfbuy);
export default __webpack_public_path__ + "static/media/mfbuy.1fb1eba64590b35dbccd94b40f7a8788.svg";
export { ForwardRef as ReactComponent };